import { render, staticRenderFns } from "./AdminMenuDrawer.vue?vue&type=template&id=bfad9aa2&scoped=true&"
import script from "./AdminMenuDrawer.vue?vue&type=script&lang=js&"
export * from "./AdminMenuDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuDrawer.vue?vue&type=style&index=0&id=bfad9aa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfad9aa2",
  null
  
)

export default component.exports